export interface CustomerEmployee {
  id: string
  name: string
  vatNumber?: string
  businessName?: string
  address?: string
  postCode?: string
  city?: string
  state?: string
  country?: string
}

export interface CompanyEmployee {
  id: string
  name: string // Nombre comercial
  role: Role
  inactive: boolean
  removed?: boolean
  linkedAt?: string
  inactiveDate?: string
  externalCustomer?: CustomerEmployee
}

export default interface Employee {
  id: string
  name: string
  surname: string
  email: string
  phoneNumber: string
  nif: string
  companies: CompanyEmployee[]
  billingCompanyId?: string

  resolvedBillingCompanyId?: string
  resolvedBillingCompanyName?: string
  billingEntityId?: string
  billingEntityName?: string
  operatingCompanyBillingCompanyId?: string | null

  deliveryNotesCount?: number
  workingDaysCount?: number
}

export interface EmployeeBilling {
  employeeId: string
  storedBillingCompanyId?: string
  resolvedBillingCompanyId?: string
  companies: Array<{
    companyId: string
    companyName?: string
    inactive?: boolean
    linkedAt?: string
  }>
}

export interface EmployeeResponse {
  employees: Employee[]
}

export interface EmployeeRequest {
  id: string
  name: string
  surname: string
  email: string
  phoneNumber: string
  nif: string
  role: Role
  inactive?: boolean
}

export interface EmployeeImportRequest {
  name: string
  surname: string
  email: string
  phoneNumber: string
  nif: string
  role?: Role
  inactive?: boolean
  externalCustomerVat?: string
}

export enum EmployeeBulkFailedReason {
  MISSING_NAME = 'MISSING_NAME',
  MISSING_SURNAME = 'MISSING_SURNAME',
  MISSING_EMAIL = 'MISSING_EMAIL',
  INVALID_EMAIL = 'INVALID_EMAIL',
  MISSING_ROLE = 'MISSING_ROLE',
  INVALID_ROLE = 'INVALID_ROLE',
  DUPLICATE_EMAIL = 'DUPLICATE_EMAIL',
  INVALID_EXTERNAL_CUSTOMER_VAT = 'INVALID_EXTERNAL_CUSTOMER_VAT',
  EXTERNAL_CUSTOMER_NOT_FOUND = 'EXTERNAL_CUSTOMER_NOT_FOUND',
  SAVE_FAILED = 'SAVE_FAILED',
}

export interface EmployeeBulkFailedInfo {
  name?: string
  surname?: string
  email?: string
  externalCustomerVat?: string
  reason: EmployeeBulkFailedReason
}

export interface EmployeeBulkCreateRs {
  created: Employee[]
  failed: EmployeeBulkFailedInfo[]
  createdCount: number
  failedCount: number
}

export enum Role {
  ADMIN = 'ADMIN',
  DRIVER = 'DRIVER'
}
